import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateObject } from "../entities.room.histories/records/updateFieldObjects";

export type Transform = {
  x: number;
  y: number;
};

type RoomTransformType = {
  objectsTransform: Transform | null;
};

type ItemMap = Record<
  string,
  { id: string; data: { x: number | undefined; y: number | undefined } }[]
>;
type ApplyItems = { roomId: string; items: ItemMap };

const initialState: RoomTransformType = {
  objectsTransform: null,
};

// SelectTypeと各sliceのnameの対応。importが循環してエラーになるためnameは定数化せず。
const itemMapKey = {
  character: "character",
  deck: "roomDecks",
  item: "roomItems",
  marker: "rooms",
  diceItem: "roomDiceSymbol",
};

const transformSlice = createSlice({
  name: "roomTransform",
  initialState: initialState,
  reducers: {
    updateTransform: (state, action: PayloadAction<Transform | null>) => {
      state.objectsTransform = action.payload;
    },
    incrementTransform: (state, action: PayloadAction<Transform>) => {
      if (state.objectsTransform !== null) {
        state.objectsTransform.x += action.payload.x;
        state.objectsTransform.y += action.payload.y;
      } else {
        state.objectsTransform = action.payload;
      }
    },
    applyItems: {
      prepare(items: UpdateObject[], roomId: string) {
        const itemsMap: ItemMap = {};
        items.forEach((item) => {
          const key = itemMapKey[item.selectType];
          const data = {
            id: item.id,
            data: { x: item.data.x, y: item.data.y },
          };
          itemsMap[key] ||= [];
          itemsMap[key].push(data);
        });
        return {
          payload: { roomId, items: itemsMap },
        };
      },
      reducer(state, _action: PayloadAction<ApplyItems>) {
        state.objectsTransform = null;
      },
    },
  },
});

export const { updateTransform, incrementTransform, applyItems } =
  transformSlice.actions;
export default transformSlice.reducer;
